export const getNumberString = (value: number) => {
  return value.toLocaleString('en-US')
}
